/*
 *
 * ApiKeys reducer
 *
 */
import produce from 'immer';
import {
  DEFAULT_ACTION,
  SAVE_FETCH_API_KEYS_RESPONSE,
  UPDATE_TABLE_DATA,
  API_CTA,
  HEADINGS,
  ENABLE_LOADER,
  DISABLE_LOADER,
  SAVE_GENERATE_API_KEY_RESPONSE,
  SAVE_RESET_API_KEY_RESPONSE,
  RESET_RESPONSE,
  SAVE_GET_API_KEY_BY_APP_ID_RESPONSE,
  RESET_DATA,
} from './constants';

import { DEFAULT_LIMIT, DEFAULT_CURRENT_PAGE } from '../../utils/constants';

const getInitialState = () => ({
  isLoading: false,
  headingData: HEADINGS.ALL,
  filters: {
    pageSize: DEFAULT_LIMIT,
    pageNo: DEFAULT_CURRENT_PAGE,
  },
  data: [],
  totalCount: 0,
  hasPrev: false,
  hasNext: false,
  currentPageRowData: [],
  filtersForDisplay: {},
  buttonContent: 'Generate API Keys',
  buttonCTAModal: API_CTA,
  apiKeyModalResponse: {},
});

export const initialState = {
  ...getInitialState(),
};

/* eslint-disable default-case, no-param-reassign */
const apiKeysReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case DEFAULT_ACTION:
        break;
      case SAVE_FETCH_API_KEYS_RESPONSE: {
        const { data } = action.data;
        if (data && Object.keys(data).length > 0) {
          draft.data = [data];
        } else {
          draft.data = [];
        }
        draft.isLoading = false;
        break;
      }
      case SAVE_GET_API_KEY_BY_APP_ID_RESPONSE:
      case SAVE_GENERATE_API_KEY_RESPONSE:
      case SAVE_RESET_API_KEY_RESPONSE: {
        const { data } = action.data;
        draft.apiKeyModalResponse = data;
        draft.isLoading = false;
        break;
      }
      case RESET_RESPONSE: {
        draft.apiKeyModalResponse = {};
        break;
      }
      case UPDATE_TABLE_DATA: {
        const {
          totalCount,
          currentPageRowData,
          hasPrevEnabled,
          hasNextEnabled,
        } = action.data;
        draft.totalCount = totalCount;
        draft.hasPrev = hasPrevEnabled;
        draft.hasNext = hasNextEnabled;
        draft.currentPageRowData = currentPageRowData;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case RESET_DATA: {
        const obj = getInitialState();
        Object.keys(obj).forEach(k => (draft[k] = obj[k])); // eslint-disable-line
        break;
      }
    }
  });

export default apiKeysReducer;
